import cn from 'classnames';
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import styles from './Button.module.scss';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant: 'primary' | 'secondary' | 'thirdy' | 'special';
    form?: 'rounded' | 'square';
    size?: 'large' | 'medium' | 'small';
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ variant, form = 'rounded', size = 'medium', className, children, ...buttonProps }, ref) => (
        <button
            ref={ref}
            className={cn(styles.button, styles[variant], styles[form], styles[size], className)}
            {...buttonProps}
        >
            {children}
        </button>
    )
);

Button.displayName = 'Button';
